// extracted by mini-css-extract-plugin
module.exports = {"SMovieGrid":"RelatedMovies_SMovieGrid__L8MQY","SCultureGrid":"RelatedMovies_SCultureGrid__1HHQt","SMovie":"RelatedMovies_SMovie__vtYVz"};